import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { TransactionResultCardOpTypes, TransactionResultModel, TransactionResultReqParamsModel } from '../../models/transaction-result-models';
import { CookieManagementService } from 'src/app/account/services/cookie-management.service';
import { AppConfig } from 'src/app/config-service/app.config';

@Injectable({
  providedIn: 'root'
})
export class TransactionResultService {
  private accessToken = '';

  constructor(
    private http:HttpClient,
    private cookieManagementService: CookieManagementService
  ) { }

  transactionComplete = (bodyParams:TransactionResultReqParamsModel, card_ops_type: TransactionResultCardOpTypes) : Observable<TransactionResultModel> => {
    this.accessToken = this.cookieManagementService.getAccessToken();
    if (this.accessToken == '') {
      return new Observable();
    } else {
      const headers:HttpHeaders = this.setHeaders(this.accessToken);
      const body:URLSearchParams = this.setBody(bodyParams, card_ops_type);

      return this.http
      .post<TransactionResultModel>(
        AppConfig.settings.apiServer.url + "api/transaction/complete", body.toString(),
        {
          headers: headers,
          params: {
            region: AppConfig.settings.city.region,
            lang: AppConfig.settings.apiServer.lang,
            authType: AppConfig.settings.apiServer.authType,
          },
        }
      ).pipe(
        catchError((error) => {
          throw new Error(error);
        })
      );
    }

  }

  private setBody = (bodyParams:TransactionResultReqParamsModel, card_ops_type: TransactionResultCardOpTypes) : URLSearchParams => {
    let body = new TransactionResultBodyCreator().getBody(card_ops_type);

    Object.entries(bodyParams).forEach(
      ([key, value]) => {
        body.set(key, value)
      }
    );

    return body;
  }

  private setHeaders = (accessToken:string) : HttpHeaders => {
    accessToken = 'Bearer ' + accessToken;

    return new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      authorization: accessToken,
    });
  }

}

class TransactionResultBodyCreator{
  getBody(card_ops_type: TransactionResultCardOpTypes){
    if(card_ops_type == 'card-save'){
      return new TransactionResultSaveCardBody().getBody();
    }else if(card_ops_type == 'pay-with-credit-card'){
      return new TransactionResultCreditCardBody().getBody()
    }else if(card_ops_type == 'pay-with-defined-card'){
      return new TransactionResultDefinedCardBody().getBody();
    }else if(card_ops_type == "etisalat"){
      return new TransactionResultEtisalatBody().getBody();
    }
    else{
      throw new Error('Error: unknown card operation type is passed as parameter!');
    }
  }
}

interface TransactionResultBody{
  getBody():URLSearchParams
}

class TransactionResultDefinedCardBody implements TransactionResultBody{

  getBody() {
    let body = new URLSearchParams();

    const card_type = localStorage.getItem('card-type')!

    body.set('card_type', card_type);
    body.set('transaction_type', '7');
    body.set('payment_type', '15');

    return body;
  }

}

class TransactionResultCreditCardBody implements TransactionResultBody{

  getBody() {
    let body = new URLSearchParams();

    const card_type = localStorage.getItem('card-type')!

    body.set('card_type', card_type);
    body.set('transaction_type', '7');
    body.set('payment_type', '15');

    return body;
  }

}

class TransactionResultSaveCardBody implements TransactionResultBody{

  getBody() {
    let body = new URLSearchParams();

    const card_type = localStorage.getItem('card-type')!

    body.set('card_type', card_type);
    body.set('transaction_type', '4');
    body.set('payment_type', '14');

    return body;
  }

}

class TransactionResultEtisalatBody implements TransactionResultBody{

  getBody() {
    let body = new URLSearchParams();

    const card_type = localStorage.getItem('card-type')!

    body.set('card_type', card_type);
    body.set('transaction_type', '6');
    body.set('payment_type', '24');

    return body;
  }

}